import { __rest as e } from "tslib";
import * as o from "react";
import a from "classnames";
import { ComponentClassNames as t, ComponentText as i } from "../shared/constants.js";
import { CountryCodeSelect as l } from "./CountryCodeSelect.js";
import { TextField as r } from "../TextField/TextField.js";
var d = o.forwardRef(function (d, n) {
  var _d$autoComplete = d.autoComplete,
      s = _d$autoComplete === void 0 ? "tel-national" : _d$autoComplete,
      C = d.className,
      m = d.countryCodeName,
      _d$countryCodeLabel = d.countryCodeLabel,
      u = _d$countryCodeLabel === void 0 ? i.PhoneNumberField.countryCodeLabel : _d$countryCodeLabel,
      c = d.countryCodeRef,
      y = d.defaultCountryCode,
      f = d.defaultDialCode,
      _d$dialCodeLabel = d.dialCodeLabel,
      p = _d$dialCodeLabel === void 0 ? i.PhoneNumberField.countryCodeLabel : _d$dialCodeLabel,
      b = d.dialCodeList,
      h = d.dialCodeName,
      N = d.dialCodeRef,
      L = d.hasError,
      R = d.isDisabled,
      D = d.isReadOnly,
      g = d.onCountryCodeChange,
      E = d.onDialCodeChange,
      F = d.onInput,
      v = d.size,
      O = d.type,
      j = d.variation,
      z = e(d, ["autoComplete", "className", "countryCodeName", "countryCodeLabel", "countryCodeRef", "defaultCountryCode", "defaultDialCode", "dialCodeLabel", "dialCodeList", "dialCodeName", "dialCodeRef", "hasError", "isDisabled", "isReadOnly", "onCountryCodeChange", "onDialCodeChange", "onInput", "size", "type", "variation"]);
  var P = h || m,
      x = p || u,
      I = f || y,
      S = E || g,
      T = N || c;
  return o.createElement(r, Object.assign({
    outerStartComponent: o.createElement(l, {
      defaultValue: I,
      dialCodeList: b,
      className: C,
      hasError: L,
      isDisabled: R,
      isReadOnly: D,
      label: x,
      name: P,
      onChange: S,
      ref: T,
      size: v,
      variation: j
    }),
    autoComplete: s,
    className: a(t.PhoneNumberField, C),
    hasError: L,
    isDisabled: R,
    isReadOnly: D,
    isMultiline: !1,
    onInput: F,
    ref: n,
    size: v,
    type: "tel",
    variation: j
  }, z));
});
d.displayName = "PhoneNumberField";
export { d as PhoneNumberField };